import type { PartialParentWithTravelerContext } from "@checkout/states/common/TravelerInformation";
import { SAVE_TRAVELER } from "@hopper-b2b/types";
import { trackBaseEvent } from "../utils";

export const trackSaveTraveler = async (
  context: PartialParentWithTravelerContext
) =>
  trackBaseEvent(context, {
    eventName: SAVE_TRAVELER,
    properties: {},
  });
